import React, { useEffect, useState } from "react";
import EmailLogTable from "../../components/EmailLogTable/EmailLogTable";
import { getEmailLogs } from "../../api/email/getEmailLogs";
import { getAccounts } from "../../api/account";
import { getTemplates, Template } from "../../api/email/getTemplates";
import { EmailLog, EmailLogsRequest } from "../../types/model/email";
import { Account } from "../../types/model/account";
import { SelectChangeEvent } from "@mui/material";

const EmailLogsPage = () => {
  const [logs, setLogs] = useState<EmailLog[]>([]);
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [templates, setTemplates] = useState<Template[]>([]);
  const [filters, setFilters] = useState<EmailLogsRequest>({});

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const accounts = await getAccounts();
        setAccounts(accounts);
      } catch (error) {
        console.error("Error fetching accounts:", error);
      }
    };
    const fetchTemplates = async () => {
      try {
        const templates = await getTemplates();
        setTemplates(templates);
      } catch (error) {
        console.error("Error fetching templates:", error);
      }
    };
    fetchAccounts();
    fetchTemplates();
  }, []);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const logs = await getEmailLogs(filters);
        setLogs(logs);
      } catch (error) {
        console.error("Error fetching email logs:", error);
      }
    };
    fetchLogs();
  }, [filters]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name as string]: value }));
  };

  const handleSelectChange = (e: SelectChangeEvent<string>) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name as string]: value }));
  };

  return (
    <EmailLogTable
      logs={logs}
      accounts={accounts}
      templates={templates}
      filters={filters}
      onInputChange={handleInputChange}
      onSelectChange={handleSelectChange}
    />
  );
};

export default EmailLogsPage;
